
import MessageClient from "./MessageClient";
import { Constants } from "../../constants/constants";
import { IUserReactionResponse } from "../../commons/interfaces";

interface IRequestReaction {
    userId: string;
    clientId: string;
    targetId: string;
    targetType: number;
    reactionCode: number;
    organizationId: string;
}

const UserReactionService = {
    reaction: async (data: IRequestReaction): Promise<IUserReactionResponse> => {
        const result = await MessageClient().post(Constants.ApiPath.UserReaction.REACTION, data);
        return result.data.result;
    },
    
    unReacted: async (data: { id: string }): Promise<IUserReactionResponse> => {
        const result = await MessageClient().post(`${Constants.ApiPath.UserReaction.UNREACTED}/${data.id}`, data);
        return result.data.result;
    },
};

export default UserReactionService;
